export default __webpack_public_path__ + "static/media/dl-1.7217ceb4.png";